import {
  Box,
  Drawer,
  DrawerContent,
  Flex,
  IconButton,
  useBreakpointValue,
  useColorModeValue,
} from "@chakra-ui/react";
import { RiCloseLine } from "react-icons/ri";
import { useEffect, useState } from "react";

export function SidePanel({
  showPanel,
  setSidePanelContent,
  children,
}: {
  showPanel: boolean;
  setSidePanelContent: () => void;
  children: React.ReactNode;
}) {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.getElementById("sticky-header");
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
    return () => window.removeEventListener("resize", updateHeaderHeight);
  }, []);

  const useDrawer = useBreakpointValue(
    {
      base: true,
      "2xl": false,
    },
    { ssr: false }
  );

  if (useDrawer) {
    return (
      <Drawer
        id="side-panel"
        isOpen={showPanel}
        size="lg"
        placement="right"
        onClose={setSidePanelContent}
      >
        <DrawerContent
          overflow={"auto"}
          bg={bg}
          borderRadius={10}
          border={"solid"}
          borderColor={borderColor}
          px={8}
          height={"85vh"}
          marginTop={"5vh"}
          display="flex"
          flexDirection="column"
        >
          <Box bg={bg} flexShrink={0} position="sticky" top={0} right={0} zIndex={2}>
            <SidePanelActions setSidePanelContent={setSidePanelContent} />
          </Box>
          <Flex flex={1} minH={0} overflow={"auto"}>
            <Box w="100%">{children}</Box>
          </Flex>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Box
      id="side-panel"
      hidden={!showPanel}
      width={"35vw"}
      // height="auto"
      top={headerHeight + 10}
      position="sticky"
      ml={6}
      overflow={"auto"}
      height="86vh"
      bg={bg}
      borderRadius={10}
      border={"solid"}
      borderColor={borderColor}
      px={8}
      display="flex"
      flexDirection="column"
      maxH={`calc(100vh - ${headerHeight + 20}px)`}
    >
      <Box flexShrink={0}>
        <SidePanelActions setSidePanelContent={setSidePanelContent} />
      </Box>
      <Flex flex={1} minH={0} overflow={"auto"}>
        <Box w="100%">{children}</Box>
      </Flex>
    </Box>
  );
}

function SidePanelActions({ setSidePanelContent }: { setSidePanelContent: () => void }) {
  return (
    <Flex flexDirection={"row"} pt={2} mb={2} justifyContent={"flex-end"}>
      <IconButton
        background={"transparent"}
        aria-label="Close side panel"
        icon={<RiCloseLine />}
        onClick={setSidePanelContent}
      />
    </Flex>
  );
}
